import React from "react";
import { useTranslation } from "react-i18next";

const Loading = () => {
    const { t } = useTranslation(); // useTranslation 훅 사용

    return (
        <div
            style={{
                width: "100%",
                height: "100vh", // 전체 화면 높이
                display: "flex",
                flexDirection: "column", // 세로 정렬
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                top: 0,
                left: 0,
                backgroundColor: "rgba(255, 255, 255, 0.9)", // 배경을 약간 흐리게
                zIndex: 9999,
            }}
        >
            {/* 로딩 메시지 (다국어 지원) */}
            <div
                style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "rgb(30 100 152)",
                    marginBottom: "10px", // 로딩 바와 간격 조정
                }}
            >
                {t("Loading")} {/* i18n 키값 사용 */}
            </div>

            {/* 로딩 바 */}
            <div
                style={{
                    width: "300px", // 바의 너비 조정
                    height: "15px",
                    backgroundColor: "#e0e0e0",
                    position: "relative",
                    overflow: "hidden",
                    borderRadius: "2px",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#1e83ce",
                        position: "absolute",
                        animation: "loadingBarAnim 1.5s infinite",
                    }}
                />
            </div>
            <style>
                {`
                    @keyframes loadingBarAnim {
                        0% { left: -30%; }
                        50% { left: 50%; width: 40%; }
                        100% { left: 100%; width: 30%; }
                    }
                `}
            </style>
        </div>
    );
};

export default Loading;
